import { Debug, Utils, ReduxSagaRequest, Request } from "@hlibs/index";
import Language from "@app/language";

export const UploadAdBanner = async (payload, callback, reduxModule) => {
  const stateKey = "UploadAdBanner";

  // if (Utils.checkNullOrEmpty(payload, payload.file))
  //   return ReduxSagaRequest.makeResult.failureWithMessage(
  //     Language.Server.err3,
  //     stateKey
  //   );
  try {
    let formData = new FormData();
    formData.append("file", payload.file);
    const response = await Request.post("/file/upload/adbanner", formData, {
      headers: { "content-type": "multipart/form-data" },
    });
    const { data } = response;
    if (callback) callback(data, response);

    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (Utils.checkKeyExists(data, ["id"])) {
      reduxModule.set(data, "file");

      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};
